import { useEffect, useState } from 'react';

function computeStandalone() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  const mql = window.matchMedia('(display-mode: standalone)');
  if (!mql) return false;
  const ios = window.navigator && window.navigator.standalone === true;
  return mql.matches || ios;
}

export function useStandaloneMode() {
  const [isStandalone, setIsStandalone] = useState(computeStandalone);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia('(display-mode: standalone)');
    if (!mql) return undefined;
    const ios = window.navigator && window.navigator.standalone === true;
    const onChange = (e) => setIsStandalone(e.matches || ios);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return { isStandalone };
}
